import React, { useContext } from "react";
import { get } from "../../utils/helpers";
import { actions } from "../../hooks/useAppState";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { AppStateContext } from "../App";

export default function AppLanguageSwitcher() {
  // Shared state/context
  const [appState, doAppStateAction] = useContext(AppStateContext);
  const config = appState.config;

  var getLanguages = () => {
    if (config.customise.languageSwitcher.showOnlyZoneLanguages) {
      return get(config, ["zones", appState.zone, "supportedLanguages"]);
    } else {
      return get(config, "languages.supportedLanguages");
    }
  };

  const sort: boolean = get(config, "languages.sort");

  // laod every time instead of useMemo - to reload after getting config from api
  var languages = getLanguages();

  // Event handlers
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLanguage = event.target.value;
    if (newLanguage !== appState.language) {
      doAppStateAction(actions.setLanguage(newLanguage));
    }
  };

  return (
    <LanguageSwitcher
      currentLanguage={appState.language}
      languages={languages}
      sortOptions={sort}
      onChange={handleChange}
    />
  );
}
